import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "./store/store";
import { fetchStateData } from "./redux/common/commonSlice";
import useLivevoxCleanup from "./hooks/useLivevoxCleanup";

const AppInitializer = () => {
  const dispatch = useDispatch();
  const cmsStatus = useSelector((state) => state.cms.status);
  const hasFetchedRed = useRef(false); // added to prevent double fetch

  useLivevoxCleanup();

  // Clear persisted data only on reload
  useEffect(() => {
    const navEntries = performance.getEntriesByType("navigation");
    const navType = navEntries.length > 0 ? navEntries[0].type : "navigate";

    if (navType === "reload") {
      persistor.purge().then(() => {
        if (!hasFetchedRed.current) {
          dispatch({ type: "cms/fetchAll" });
          hasFetchedRed.current = true;
        }
      });
    }
  }, []);

  useEffect(() => {
  if (
    (cmsStatus === "idle" || cmsStatus === "failed") &&
    !hasFetchedRed.current
  ) {
    dispatch({ type: "cms/fetchAll" });
    hasFetchedRed.current = true;
  }
}, [cmsStatus, dispatch]);

  // useEffect(() => {
  //   requestIdleCallback(() => {
  //     if (
  //       (cmsStatus === "idle" || cmsStatus === "failed") &&
  //       !hasFetchedRed.current
  //     ) {
  //       dispatch({ type: "cms/fetchAll" });
  //       hasFetchedRed.current = true;
  //     }
  //   });
  // }, [cmsStatus, dispatch]);

  useEffect(() => {
    // Fetch state data once when the app initializes
    dispatch(fetchStateData());
  }, [dispatch]);

  return null;
};

export default AppInitializer;
